import React from "react";

import { LAYOUT_MODE_TYPES } from "../../Components/constants/layout";
import { requestJson } from "../../helpers/api";
import { guardarTemaLocal } from "../../helpers/themeStorage";
import { ConfiguracionSesionDto } from "../../types/auth";

interface LightDarkProps {
  layoutMode: string;
  onChangeLayoutMode: (mode: string) => void;
}

const actualizarTemaPersistido = async (tema: string) => {
  try {
    const respuesta = await requestJson<ConfiguracionSesionDto>(
      "/api/usuarios/configuracion",
      {
        method: "PUT",
        body: JSON.stringify({ tema }),
      },
    );
    if (typeof window === "undefined") {
      return;
    }
    const raw = sessionStorage.getItem("authUser");
    if (!raw) {
      return;
    }
    const parsed = JSON.parse(raw);
    parsed.configuracion = {
      ...(parsed.configuracion || {}),
      ...respuesta,
    };
    sessionStorage.setItem("authUser", JSON.stringify(parsed));
    guardarTemaLocal(respuesta.tema);
  } catch (error) {
    console.error("No se pudo guardar la preferencia de tema", error);
  }
};

const LightDark = ({ layoutMode, onChangeLayoutMode }: LightDarkProps) => {
  const targetMode =
    layoutMode === LAYOUT_MODE_TYPES["DARKMODE"]
      ? LAYOUT_MODE_TYPES["LIGHTMODE"]
      : LAYOUT_MODE_TYPES["DARKMODE"];

  const handleToggle = () => {
    onChangeLayoutMode(targetMode);
    void actualizarTemaPersistido(targetMode);
  };

  return (
    <div className="ms-1 header-item d-none d-sm-flex">
      <button
        onClick={handleToggle}
        type="button"
        className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle light-dark-mode"
      >
        <i className="bx bx-moon fs-22"></i>
      </button>
    </div>
  );
};

export default LightDark;
